@import 'styles/variables';

.mergeIcon {
  color: var(--action-50);
}
